import styled, { css } from 'styled-components';
import NavArrow from '../images/nav-arrow.svg';

const V2ArrowContainerStyles = css`
  max-width: 1196px;
  justify-content: flex-end;
  padding: 0 28px;
  @media (min-width: 1252px) {
    padding: 0;
  }
  @media (max-width: 825px) {
    padding: 0 28px;
  }
`;

const V3ArrowContainerStyles = css`
  max-width: 1240px;
  justify-content: space-between;
  padding: 0;
  @media (max-width: 824px) {
    padding: 0 28px;
    justify-content: flex-end;
  }
`;

const BenderArrowContainerStyles = css`
  max-width: 1336px;
  padding: 0 28px;
  align-items: center;
  gap: 0 20px;

  div {
    width: 60px;
    height: 60px;
    background-color: var(--dark);
    background-image: url(${NavArrow});
    background-repeat: no-repeat;
    background-position: 22px center;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0 20px;
    cursor: pointer;

    &:last-child {
      transform: scale(-1);
    }

    @media (max-width: 575px) {
      width: 40px;
      height: 40px;
      background-position: 12px center;
    }
  }

  @media (max-width: 767px) {
    padding: 0 20px;
  }
`;

const SliderContainer = styled.div`
  position: absolute;
  z-index: 500;
  width: 100%;
  ${({ versionStyling }) =>
    versionStyling === 'V3' &&
    `
      @media (min-width: 825px) {
        top: 50% !important;
      }
  `}
  ${({ versionStyling }) =>
    versionStyling === 'V5' &&
    `
    top: 0;
    @media (max-width: 575px) {
      top: -55px;
      .header-items {
        display: flex;
      }
      .arrow-container {
        display: none;
      }
    }
  `}
  ${({ versionStyling }) =>
    versionStyling === 'Bender' &&
    `
    bottom: 0;
    margin-bottom: 70px;

    @media (max-width: 767px) {
      margin-bottom: 40px;
    }

    @media (max-width: 575px) {
      margin-bottom: 20px;
    }
  `}
  ${({ top }) => !!top && `top: ${top}px !important`};
`;

const ArrowContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;

  .left-arrow,
  .right-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    border: none;
    color: var(--grey-5);
    cursor: pointer;
    width: 60px;
    height: 60px;
    outline: none;
    touch-action: manipulation;
    background: var(--grey-3);
    &:hover {
      background: var(--titan-blue-3);
      color: #fff;
    }
    &.active {
      background: var(--titan-blue-3) !important;
      color: #fff !important;
    }
    svg {
      margin: 0 !important;
      transform: none !important;
    }
  }
  @media (hover: none) {
    .left-arrow:hover,
    .right-arrow:hover {
      background: var(--grey-3);
      color: var(--grey-5);
    }
  }
  svg:first-child {
    margin-right: 10px;
  }
  svg:last-child {
    transform: scale(-1);
  }
  svg {
    cursor: pointer;
    use path {
      fill: red !important;
    }
  }
  svg.disabled {
    opacity: 0.5;
  }
  ${({ versionStyling }) =>
    versionStyling === 'Bender'
      ? BenderArrowContainerStyles
      : versionStyling === 'V2' || versionStyling === 'V5'
      ? V2ArrowContainerStyles
      : V3ArrowContainerStyles};
  @media (max-width: 575px) {
    .left-arrow,
    .right-arrow {
      width: 40px;
      height: 40px;
    }
  }
`;

const HeaderItems = styled.div`
  display: none;
  align-items: center;
  justify-content: left;
  position: relative;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  user-select: none;
  ::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  > p {
    cursor: pointer;
    border: 1px solid var(--grey-2);
    border-radius: 4px;
    padding: 10px 15px 10px 15px;
    letter-spacing: 0em;
    text-align: center;
    color: var(--black);
    margin-right: 10px;
    white-space: nowrap;

    &.selected {
      background: var(--black);
      color: var(--white);
    }
  }
`;

export { SliderContainer, ArrowContainer, HeaderItems };
